// @flow
import { CategoriesTravelActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    categoryTravel: {},
    listaCategoriesTravel: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type CategoriesTravelAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoryTravel?: {} | null, listaCategoriesTravel?: [] | null, loading?: boolean, +value ?: boolean };

const CategoriesTravel = (state: State = INIT_STATE, action: CategoriesTravelAction): any => {
    // console.log(action);
    switch (action.type) {
        case CategoriesTravelActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        categoryTravel: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL: {
                    return {
                        ...state,
                        listaCategoriesTravel: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriesTravelActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoryTravel: {},
                        loading: false,
                    };
                }
                case CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategoriesTravel: [],
                        loading: false,
                    };
                }
                case CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL:
            return { ...state, error: false, loading: true };
        case CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL:
            return { ...state, error: false, loading: true };
        case CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL:
            return { ...state, error: false, loadingForm: true };
        case CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL:
            return { ...state, error: false, loadingForm: true };
        case CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL:
            return { ...state, error: false, loading: true };
        case CategoriesTravelActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                categoryTravel: {},
                listaCategoriesTravel: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default CategoriesTravel;
